import { Chip } from '@mui/material'
import { FC } from 'react'
import { useRecordContext, useTranslate } from 'react-admin'
import { CertificateOut, CertificateStatus } from '../types/apiRequests'

interface Props {
  listView?: boolean
}

const StatusChip: FC<Props> = ({ listView }) => {
  const record = useRecordContext<CertificateOut>()
  const translate = useTranslate()
  if (!record?.status) return null

  const colorMap: Record<CertificateStatus, 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info'> = {
    PENDING: 'warning',
    CSR_READY: 'info',
    CSR_DOWNLOADED: 'info',
    CERT_UPLOADED: 'primary',
    INSTALL_SCHEDULED: 'primary',
    ACTIVE: 'success',
    EXPIRED: 'error',
    ERROR: 'error',
  }
  const label = translate(`resources.certificates.status.${record.status}`, { _: record.status })

  return <Chip
    label={label}
    color={colorMap[record.status] ?? 'default'}
    sx={{ mb: listView ? 0 : 2, minWidth: 120 }}
    variant={listView ? 'outlined' : 'filled'}
    size={listView ? 'small' : 'medium'}
  />
}

export default StatusChip